import { RunConfigService, ConfigService } from "@nuskin/ns-util";
import axios from "axios";

export default {
  getProductData
};

/**
 * Used to retrieve product content and product status for products requested from the product data lambda.
 * @param skus The product skus to request data for.
 * @param locale The locale for market-specific product data and translations.
 * @return {Promise.<*>}
 */
async function getProductData(skus, locale) {
  if (!locale) {
    const runConfig = RunConfigService.getRunConfig();
    locale = `${runConfig.language}_${runConfig.country}`;
  }

  const marketConfig = ConfigService.getMarketConfig();

  let lambdaUrl = `${marketConfig.awsUrl}/productData/v1`;
  const payload = {
    locale: locale,
    skus: skus
  };
  const productDataResponse = await axios.request({
    method: "post",
    url: lambdaUrl,
    data: payload,
    headers: _getHeaders(),
    responseType: "json"
  });
  const productData = productDataResponse.data;
  return productData;
}

/**
 * Returns headers required to call product data lambda
 * @returns {{Content-Type: string, client_id: string, client_secret: string}}
 * @private
 */
function _getHeaders() {
  let config = ConfigService.getMarketConfig();

  return {
    "Content-Type": "application/json",
    client_id: config.checkout.clientId,
    client_secret: config.checkout.clientSecret
  };
}
